module.exports = __webpack_public_path__ + "img/asian-noodle-soup-1.aa38f159.jpg";